export type Step = 'landing' | 'quiz' | 'analyzing' | 'sales';

export interface QuizQuestion {
  id: number;
  question: string;
  options: string[];
}

export const QUIZ_QUESTIONS: QuizQuestion[] = [
  {
    id: 1,
    question: "Quanto você ganha por mês?",
    options: [
      "Até R$ 3.000",
      "Entre R$ 3.000 e R$ 8.000",
      "Entre R$ 8.000 e R$ 15.000",
      "Mais de R$ 15.000"
    ]
  },
  {
    id: 2,
    question: "O que te impede de investir em crypto hoje?",
    options: [
      "Tenho medo de perder dinheiro",
      "Não sei por onde começar",
      "Já perdi dinheiro antes",
      "Acho muito complicado"
    ]
  },
  {
    id: 3,
    question: "Quanto você pode investir por mês SEM comprometer suas contas?",
    options: [
      "R$ 50 - R$ 100",
      "R$ 200 - R$ 500",
      "R$ 1.000+",
      "Tenho um capital alto parado"
    ]
  },
  {
    id: 4,
    question: "Qual sua experiência com o mercado?",
    options: [
      "Totalmente iniciante (Nunca comprei)",
      "Já comprei, mas sem estratégia",
      "Já invisto, mas quero lucrar mais",
      "Sou trader experiente"
    ]
  },
  {
    id: 5,
    question: "Qual seu maior objetivo agora?",
    options: [
      "Proteger meu patrimônio (Segurança)",
      "Renda extra consistente (Cautela)",
      "Multiplicar capital rápido (Risco Médio)",
      "Ficar rico com uma explosão (Alto Risco)"
    ]
  }
];

export interface FunnelState {
  currentStep: Step;
  answers: number[]; // Index of selected answers
}